module.exports = __webpack_public_path__ + "img/sport_tv_2a.3ae67f76.png";